module.exports = "/images/vendor/vue2vis/dist/backIcon.png?dd0baa69a69937600dc3bf035f3873c4";